import { InjectionToken } from '@angular/core';
import { IFloorsService } from '../../interfaces/services/floors-service.interface';

export const FLOORS_SERVICE = new InjectionToken<IFloorsService>('FloorsService');
